// services/autoGenerateContent.ts
import { ApiCall } from "components/common/services/ApiServices";
import { AJ_WEB_CONNECTOR } from "Constants";
import { GENERATE_CONTENT_BY_MODIFIED_PROMPT, GET_USER_PROMPT } from "routes/ApiEndpoints";
import { convertMarkdownToHtml } from "../utlis/HelperFunctions";
import CustomNotify from "components/common/atoms/CustomNotify";
import { t } from "components/CentralDataMangement/translation/Translation";

const prompts = {
  job_description: {
    prompt:
      "Create a job description for {{job_title}} in {{location}} following this EXACT structure: 1.One bullet point introducing the role and location with enthusiasm. 2. Exactly three bullet points describing key job tasks and responsibilities, each 12–18 words, clear and concise. 3. Only if salary fields are filled: include one detailed sentence about {{salary_range}} and explain one other specific benefit in detail. If the fields are left empty, skip this sentence entirely and do not include any mention of salary or use phrases like 'competitive salary'. 4. One bullet point about work schedule: {{work_hours}} and {{contract_type}} with additional scheduling details. 5. One bullet point about working environment, team culture, and company atmosphere. 6. One bullet point on closing sentence with strong call to apply through Absolute Jobs.Use • symbol at the start of every bullet point",
    slug: "",
  },
  job_offer: {
    prompt:
    "Create a job offer section for {{job_title}} in {{location}} following this EXACT structure: 1. Heading: What We Offer (no bold, and translate according to the langauge).2. Provide exactly 5–7 bullet points using the • symbol, each 10–15 words long. Bullet points should describe salary and wage package elements in an appealing way without explicitly mentioning salary, contract type (focus only on salary and wage elements).  . 3. End with one bullet point containing a strong call to apply. Content Rules: No introduction or requirements. Highlight Absolute Jobs advantages.",
    slug: "",
  },
  profile_description: {
    prompt:
    "Create a requirements section for {{job_title}} (the job name {{job_title}}  is in dutch) in {{location}} following this EXACT structure: 1. Heading: This Is You (no bold, and translate according to the langauge). 2. Exactly 5-7 bullet points using • symbol covering: experience (Use this exact sentence: {{experience_sentence}}), education (Use the value {{studies}} only if it exists — list all items), licenses (Use the value {{driver_licenses}} or {{additional_certificates}} only if it exists — list all exactly as given), technical skills (only if data is available and technical skill term is applicable for the realted job that is {{job_title}}), and soft skills (only if data is available and soft skill term is applicable for the realted job that is {{job_title}}) else provide the skills. If fewer than 5 data categories are available, rephrase or expand available ones to still create 5 rich bullet points. 3.Add one closing sentence about growth and opportunities 4. End with a strong call-to-action sentence motivating the reader to apply. Content Rules: No salary, benefits, client names, or job introduction. Focus only on requirements. Total length: 125-150 words exactly.",
    slug: "",
  },
  candidate_brief: {
    prompt:
      "Create a detailed candidate brief to present to {{company_name}} for the {{job_title}} position.",
    slug: "",
  },
  general: {
    prompt:
      "Create {{content_type}} about {{topic}} with the following details: {{details}}.",
    slug: "",
  },
  present_candidate_to_client: {
    prompt:
      "Write a concise and professional sales email to introduce [candidateFirstName] for the [jobTitle] role at [company]. Start with 'Hi [companyContact],' as the greeting. Use bullet points with the format 'Title: [token]' to clearly highlight key details of the candidate, including: - Work experiences: [workExperiences] - Studies: [studies] - Driving licenses: [drivingLicenses] - Transport: [transport] - Nationality: [nationality] - Date of birth: [dateOfBirth] - Place of birth: [placeOfBirth] - Country of birth: [countryOfBirth] Add a single sentence explaining why the [jobTitle] aligns well with [candidateFirstName]'s skills or career goals. Mention that other companies are interested, but [candidateFirstName] is prioritizing [company]. Include one sentence summarizing why [candidateFirstName] is ideal for the [jobTitle]. Note that the CV is attached. CRITICAL: - Use ONLY these exact tokens: [companyContact], [companyContactFirstName], [companyContactLastName], [salutation], [candidateName], [candidateFirstName], [candidateLastName], [jobTitle], [company], [workExperiences], [studies], [drivingLicenses], [transport], [nationality], [dateOfBirth], [placeOfBirth], [countryOfBirth], [link]. - Do NOT create any other bracketed placeholders. - Do NOT include subject lines or signatures. - Do NOT schedule interviews or mention meeting times. - Ensure each bullet point uses only the token with its title, without extra words or repetition. Do not repeat any tokens except [candidateFirstName] and [jobTitle]",
    slug: "present-candidate-to-company",
  },
  present_candidates_to_client: {
    prompt:
      "Write a concise professional email starting with 'Dear [companyContact],' then state 'We are pleased to introduce the following candidates for the vacancy [jobTitle] within [companyName]. Please find enclosed the CVs and fair presentations of the candidates.' followed by [candidateList], then add 'We believe that these candidates can be an absolute added value to your team at [companyName] and look forward to receiving your positive feedback, [companyContact].' Use only [companyContact], [jobTitle], [companyName], [candidateList] and nothing else.",
    slug: "present-candidates-to-company",
  },
  present_vacancy_to_candidate: {
    prompt:`
Write an enthusiastic, professional email text to present a vacancy to a candidate/applicant in the Absolute Jobs CRM system for the business unit. Use a friendly, modern and motivating style, suitable for an experienced recruiter, which enthuses the candidate and encourages them to take action. Use the language of the user input.
Use [jobTitle] for the job.Salutation: Begin with a personal salutation, such as "Dear [candidateFirstName]," followed by a brief introduction presenting the vacancy (e.g., "We have a great opportunity as an [jobTitle] at a company in the region plus brief description."). Strengths: List 4-7 attractive aspects of the vacancy in short bullet points, based on system data (e.g. salary, benefits, working environment,[contractHours]) and other relevant issues that match the candidate's interests. Make them specific and candidate-oriented (e.g. "Work on challenging AI projects"). Use one or more synonyms for the job title (e.g. artificial intelligence) for consistency. Closing and CTA: Close on a positive note about the opportunity and end with a strong, accessible call-to-action that encourages the candidate to respond quickly with two specific dates in the very near future during working days (e.g. "Let me know if you're interested, and we'll schedule an interview!").Length: Max. 500 characters (white-collar workers) or 400 characters (blue-collar workers), excluding subject line and salutation/closing. Specify which group you are writing for. For blue-collar workers: use a more direct, practical tone. Style: Enthusiastic, personal and candidate-focused, with an emphasis on what the candidate stands to gain. Follow the structure:[Salutation and introduction]. - [Aspect 1] - [Aspect 2] etc.
    `,
    slug: "present-vacancy-to-candidate",
  },
  present_vacancies_to_candidate: {
    prompt:
      "Write a concise, professional email to introduce one or more job vacancies to [candidateFirstName] for the [jobTitle] without company name. Highlight key aspects of the vacancies using bullet points—for example, role responsibilities, offer and benefits with out using any tokens. Include a single sentence that explains why the [jobTitle] is a great fit for you [candidateFirstName]'s skills or career goals. Mention that there is interest from other candidates, but emphasize that [candidateFirstName] is a top choice based on their alignment with the role(s).  Note that additional information or application details can be shared upon request. Propose two specific meeting times to discuss the opportunity further, and encourage [candidateFirstName] to suggest an alternative if those don't work.  Do not include a subject line and Do not include any closing statements like Best regards, warm regards etc.., and contact details—those are handled separately by the backend.",
    slug: "present-vacancies-to-candidate",
  },
} as const;

type PromptKey = keyof typeof prompts;
type TokenObject = Record<string, string>;

/**
 * Auto-generate content when page loads
 */
export async function autoGenerateContent(
  contentType: PromptKey,
  promptVariables: TokenObject,
  numberOfWords: number | null,
  lang: { label: string; value: string },
  addContent: (content: string) => void
) {
  try {
    // Select correct prompt
    let promptDetails = prompts[contentType];

    if (contentType === "present_candidate_to_client") {
      const dbResponse = await ApiCall.service(
        GET_USER_PROMPT,
        "POST",
        {
          promptType: "present_candidate_to_client",
          slug: "present-candidate-to-company"
        },
        true,
        AJ_WEB_CONNECTOR
      );

      if (dbResponse?.status === "success") {
        promptDetails = {
          prompt: dbResponse.data.content,
          slug: dbResponse.data.slug
        };
      }
    }

    // Replace {{tokens}} in the prompt
    const replaceTokens = (template: string, data: TokenObject): string =>
      template.replace(/{{(.*?)}}/g, (_, key) => data[key.trim()] || "");

    const expLevel = promptVariables.experience_level?.trim().toLowerCase() || "";
    promptVariables.experience_sentence =
      expLevel === "Select" || expLevel === "no" || expLevel === ""
        ? "You are eager to learn and ready to quickly gain experience in this role."
        : `You have ${promptVariables.experience_level} of experience in this role.`;

    let finalPrompt = replaceTokens(promptDetails.prompt, promptVariables);

    if (numberOfWords) {
      finalPrompt += ` Give the response in ${numberOfWords} words.`;
    }

    const entity = {
      provider_slug: "openai",
      model_slug: "gpt-4o",
      prompt: finalPrompt,
      slug: promptDetails.slug,
      content_type: contentType,
      variables: promptVariables,
      options: {
        temperature:
          contentType === "present_candidate_to_client" ||
          contentType === "present_vacancy_to_candidate"
            ? 0.1
            : 0.7,
        max_tokens: 1000,
      },
      lang,
    };

    const response = await ApiCall.service(
      GENERATE_CONTENT_BY_MODIFIED_PROMPT,
      "POST",
      entity,
      true,
      AJ_WEB_CONNECTOR
    );

    if (response?.status === "success") {
      const resData = response?.data;
      const htmlContent = await convertMarkdownToHtml(resData?.content);

      // Push it to parent callback immediately
      addContent(htmlContent);
    } else {
      CustomNotify({
        type: "error",
        message: t("Some error occurred"),
      });
    }
  } catch (err) {
    console.error("Error generating content:", err);
    CustomNotify({
      type: "error",
      message: t("Failed to generate content"),
    });
  }
}
